import {makeAutoObservable} from "mobx";
import React from "react";
import {IconProps} from "../../../../../../components/icons/icon-props-interface";
import {IChangeable} from "../../../../../../stores/types";

export interface IValidateItemRow {
    icon: React.FC<IconProps>;
    is_checked: boolean;
    label: string;
    comment: string | null;
}

export interface IValidateItemRowChange extends Partial<IValidateItemRow>{

}
class ValidateItemRowStore implements IChangeable<IValidateItemRow>{
    private _model: IValidateItemRow = {} as IValidateItemRow;
    private _changes: IValidateItemRowChange = {};

    constructor(model: IValidateItemRow, private _onIsCheckedChanged?: () => void) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setModel(model);
    }
    
    public get icon(): React.FC<IconProps> { return this._model.icon; }
    public get label(): string { return this._model.label; }
    
    private _setModel(model: IValidateItemRow){
        this._model = model;
    }
    
    public get isChecked(): boolean { return this._changes.is_checked ?? this._model.is_checked; }
    public get comment(): string { return this._changes.comment ?? this._model.comment ?? ''; }
    
    public setChecked(value: boolean) { 
        this._changes.is_checked = value; 
        if (this._onIsCheckedChanged) {
            this._onIsCheckedChanged();
        }
    }
    
    public setComment(value: string) { this._changes.comment = value; }
    
    public hasChanges(): boolean {
        throw new Error('hasChanges not impemented, the whole RMA is reloaded after vaildation');
    }
    
    public discardChanges(): void {
        throw new Error('discardChanges not impemented, the whole RMA is reloaded after vaildation');
    }
    
    public getUpdatedModel(): IValidateItemRow  {
        throw new Error('getUpdatedModel not impemented, the whole RMA is reloaded after vaildation');
    }
    
}

export { ValidateItemRowStore as default };
